import { Action } from 'redux';

export const SET_PROCESSOR_TYPE = 'super-admin-credit-card-merchant-account/SET_PROCESSORTYPE';
export const SET_PROCESSOR_TYPE_COMPLETE = 'super-admin-credit-card-merchant-account/SET_PROCESSORTYPE_COMPLETE';

export const SET_CONFIGURATION_OPTION_FORM_FIELD =
  'super-admin-credit-card-merchant-account/SET_CONFIGURATION_OPTION_FORM_FIELD';
export const ADD_CONFIGURATION_OPTION_FIELD = 'super-admin-credit-card-merchant-account/ADD_CONFIGURATION_OPTION_FIELD';
export const ADD_CONFIGURATION_OPTION_FIELD_COMPLETE =
  'super-admin-credit-card-merchant-account/ADD_CONFIGURATION_OPTION_FIELD_COMPLETE';
export const CANCEL_CONFIGURATION_OPTION_FIELD = 'super-admin-credit-card-merchant-account/CANCEL_CONFIGURATION_OPTION';
export const CANCEL_CONFIGURATION_OPTION_FIELD_COMPLETE =
  'super-admin-credit-card-merchant-account/CANCEL_CONFIGURATION_OPTION_COMPLETE';
export const SET_NAME = 'super-admin-credit-card-merchant-account/SET_NAME';
export const SET_NAME_COMPLETE = 'super-admin-credit-card-merchant-account/SET_NAME_COMPLETE';
export const RESET_NAME = 'super-admin-credit-card-merchant-account/RESET_NAME';
export const SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE =
  'super-admin-credit-card-merchant-account/SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE';
export const SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE_COMPLETE =
  'super-admin-credit-card-merchant-account/SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE_COMPLETE';
export const SET_ACCEPTED_CARD_TYPE = 'super-admin-credit-card-merchant-account/SET_ACCEPTED_CARD_TYPE';
export const SET_ACCEPTED_CARD_TYPE_COMPLETE =
  'super-admin-credit-card-merchant-account/SET_ACCEPTED_CARD_TYPE_COMPLETE';
export const CANCEL_ACCEPTED_CARD_TYPE = 'super-admin-credit-card-merchant-account/CANCEL_ACCEPTED_CARD_TYPE';
export const CANCEL_ACCEPTED_CARD_TYPE_COMPLETE =
  'super-admin-credit-card-merchant-account/CANCEL_ACCEPTED_CARD_TYPE_COMPLETE';
export const SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID =
  'super-admin-credit-card-merchent-account/SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID';
export const SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID_COMPLETE =
  'super-admin-credit-card-merchent-account/SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID_COMPLETE';
export const RESET_FIELDS = 'super-admin-credit-card-merchent-account/RESET_FIELDS';
export const CREATE_CREDIT_CARD_MERCHANT_ACCOUNT =
  'super-admin-credit-card-merchent-account/CREATE_CREDIT_CARD_MERCHANT_ACCOUNT';
export const SET_RYDIN_HELD_ACCOUNT = 'super-admin-credit-card-merchent-account/SET_RYDIN_HELD_ACCOUNT';
export const SET_RYDIN_HELD_ACCOUNT_COMPLETE = 'creditCardMerchantAccountListSET_RYDIN_HELD_ACCOUNT_COMPLETE';
export const SET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST =
  'super-admin-credit-card-merchent-account/SET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST';
export const GET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST =
  'super-admin-credit-card-merchent-account/GET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST';
export const EDIT_CREDIT_CARD_MERCHANT_ACCOUNT =
  'super-admin-credit-card-merchent-account/EDIT_CREDIT_CARD_MERCHANT_ACCOUNT';
export const EDIT_CREDIT_CARD_MERCHANT_ACCOUNT_COMPLETE =
  'super-admin-credit-card-merchent-account/EDIT_CREDIT_CARD_MERCHANT_ACCOUNT_COMPLETE';
export const UPDATE_CREDIT_CARD_MERCHANT_ACCOUNT =
  'super-admin-credit-card-merchent-account/UPDATE_CREDIT_CARD_MERCHANT_ACCOUNT';

export const setProcessorType = (data: any) => {
  return {
    type: SET_PROCESSOR_TYPE,
    payload: data,
  };
};

export const setProcessorTypeComplete = (data: any) => {
  return {
    type: SET_PROCESSOR_TYPE_COMPLETE,
    payload: data,
  };
};
export const setConfigurationOptionForm = (data: any) => {
  return {
    type: SET_CONFIGURATION_OPTION_FORM_FIELD,
    payload: data,
  };
};
export const addConfigurationOptionField = () => {
  return {
    type: ADD_CONFIGURATION_OPTION_FIELD,
  };
};
export const addConfigurationOptionFieldComplete = () => {
  return {
    type: ADD_CONFIGURATION_OPTION_FIELD_COMPLETE,
  };
};
export const cancelConfigurationOptionField = (data: any) => {
  return {
    type: CANCEL_CONFIGURATION_OPTION_FIELD,
    payload: data,
  };
};
export const cancelConfigurationOptionFieldCompleate = (data: any) => {
  return {
    type: CANCEL_CONFIGURATION_OPTION_FIELD_COMPLETE,
    payload: data,
  };
};
export const setName = (data: any) => {
  return {
    type: SET_NAME,
    payload: data,
  };
};
export const setNameComplete = (data: any) => {
  return {
    type: SET_NAME_COMPLETE,
    payload: data,
  };
};
export const resetName = () => {
  return {
    type: RESET_NAME,
  };
};
export const setConfigurationOptionFieldValue = (data: any) => {
  return {
    type: SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE,
    payload: data,
  };
};
export const setConfigurationOptionFieldValueComplete = (data: any) => {
  return {
    type: SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE_COMPLETE,
    payload: data,
  };
};
export const setAcceptedCardType = (data: any) => {
  return {
    type: SET_ACCEPTED_CARD_TYPE,
    payload: data,
  };
};
export const setAcceptedCardTypeComplete = (data: any) => {
  return {
    type: SET_ACCEPTED_CARD_TYPE_COMPLETE,
    payload: data,
  };
};

export const cancelAcceptedCardType = (data: any) => {
  return {
    type: CANCEL_ACCEPTED_CARD_TYPE,
    payload: data,
  };
};
export const cancelAcceptedCardTypeComplete = (data: any) => {
  return {
    type: CANCEL_ACCEPTED_CARD_TYPE_COMPLETE,
    payload: data,
  };
};
export const setCreditCardMerchantAccountId = (data: any) => {
  return {
    type: SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID,
    payload: data,
  };
};
export const setCreditCardMerchantAccountIdComplete = (data: any) => {
  return {
    type: SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID_COMPLETE,
    payload: data,
  };
};

export const resetFields = () => {
  return {
    type: RESET_FIELDS,
  };
};
export const createCreditCardMerchantAccount = (data: any) => {
  return {
    type: CREATE_CREDIT_CARD_MERCHANT_ACCOUNT,
    payload: data,
  };
};
export const setRydinHeldAccount = (data: boolean) => {
  return {
    type: SET_RYDIN_HELD_ACCOUNT,
    payload: data,
  };
};
export const setRydinHeldAccountComplete = (data: boolean) => {
  return {
    type: SET_RYDIN_HELD_ACCOUNT_COMPLETE,
    payload: data,
  };
};

export const getCreditCardMerchantAccountList = () => {
  return {
    type: GET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST,
  };
};
export const setCreditCardMerchantAccountList = (data: any) => {
  return {
    type: SET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST,
    payload: data,
  };
};
export const editCreditCardMerchantAccount = (data: any) => {
  return {
    type: EDIT_CREDIT_CARD_MERCHANT_ACCOUNT,
    payload: data,
  };
};
export const editCreditCardMerchantAccountComplete = (data: any) => {
  return {
    type: EDIT_CREDIT_CARD_MERCHANT_ACCOUNT_COMPLETE,
    payload: data,
  };
};
export const updateCreditCardMerchantAcoount = (data: any) => {
  return {
    type: UPDATE_CREDIT_CARD_MERCHANT_ACCOUNT,
    payload: data,
  };
};

export interface SetProcessorTypeAction extends Action<typeof SET_PROCESSOR_TYPE_COMPLETE> {
  readonly payload: any;
}
export interface SetConfigOptionFormFieldAction extends Action<typeof SET_CONFIGURATION_OPTION_FORM_FIELD> {
  readonly payload: any;
}
export interface AddConfigurationOptionFieldAction extends Action<typeof ADD_CONFIGURATION_OPTION_FIELD_COMPLETE> {}
export interface CancelConfigOptionFormFieldAction extends Action<typeof CANCEL_CONFIGURATION_OPTION_FIELD_COMPLETE> {
  readonly payload: any;
}
export interface SetNameAction extends Action<typeof SET_NAME_COMPLETE> {
  readonly payload: any;
}
export interface ResetSetNameAction extends Action<typeof RESET_NAME> {}
export interface SetConfigurationOptionFieldValueAction extends Action<
  typeof SET_CONFIGURATION_OPTION_FORM_FIELD_VALUE_COMPLETE
> {
  readonly payload: any;
}
export interface SetAcceptedCardTypeAction extends Action<typeof SET_ACCEPTED_CARD_TYPE_COMPLETE> {
  readonly payload: any;
}
export interface CancelAcceptedCardTypeAction extends Action<typeof CANCEL_ACCEPTED_CARD_TYPE_COMPLETE> {
  readonly payload: any;
}
export interface SetCreditCardMerchantAccountIdAction extends Action<
  typeof SET_CREDIT_CARD_MERCHANT_ACCOUNT_ID_COMPLETE
> {
  readonly payload: any;
}
export interface ResetFieldsAction extends Action<typeof RESET_FIELDS> {}

export interface SetRydenHeldAccountAction extends Action<typeof SET_RYDIN_HELD_ACCOUNT_COMPLETE> {
  readonly payload: boolean;
}
export interface SetCreditCardMerchantAccountListAction extends Action<typeof SET_CREDIT_CARD_MERCHANT_ACCOUNT_LIST> {
  readonly payload: any;
}
export interface EditCreditCardMerchantAccountAction extends Action<typeof EDIT_CREDIT_CARD_MERCHANT_ACCOUNT_COMPLETE> {
  readonly payload: any;
}

export type SuperAdminCreditCardMerchantAccountAction =
  | SetProcessorTypeAction
  | AddConfigurationOptionFieldAction
  | SetConfigOptionFormFieldAction
  | CancelConfigOptionFormFieldAction
  | SetNameAction
  | ResetSetNameAction
  | SetConfigurationOptionFieldValueAction
  | SetAcceptedCardTypeAction
  | CancelAcceptedCardTypeAction
  | SetCreditCardMerchantAccountIdAction
  | ResetFieldsAction
  | SetRydenHeldAccountAction
  | SetCreditCardMerchantAccountListAction
  | EditCreditCardMerchantAccountAction;
